import {observable, action, computed, runInAction, toJS} from 'mobx';

import service, {_service_without_hook} from '@service/index';
import fetchUrl from '@service/fetchUrl';

import login_user_store from '@src/Store/LoginUser/LoginUserStore';

import global_store from '@store/Common/GlobalStore';

const localStorage_agentstore_key = 'agentstore';
const localStorage_agentstoretree_key = 'agentstoretree';

class MyAgentStore {

  agentList = [];

  //树型结构
  agentTreeList = [];


  constructor() {
    this.loadLocalData()
  }


  loadLocalData() {
    let data = localStorage.getItem(localStorage_agentstore_key);

    if (data !== null) {
      this.agentList = JSON.parse(data);
    }
    let treeData = localStorage.getItem(localStorage_agentstoretree_key);

    if (treeData !== null) {
      this.agentTreeList = JSON.parse(treeData);
    }
  }

  saveLocalData() {
    localStorage.setItem(localStorage_agentstore_key, JSON.stringify(this.agentList));
    localStorage.setItem(localStorage_agentstoretree_key, JSON.stringify(this.agentTreeList));
  }

  clearLocalData() {
    this.agentList = [];
    this.agentTreeList = [];
    this.saveLocalData();
  }


  findMyAgentId(petName) {

    //是否为当前用户
    if (login_user_store.pet_name == petName) {
      return login_user_store.id;
    }

    if (this.agentList.length == 0) {
      this.loadLocalData();
    }


    for (let i = 0; i < this.agentList.length; i++) {
      let item = this.agentList[i];
      if (item.pet_name == petName) {
        return item.id;
      }
    }

    return undefined
  }

  addItemToTree(treeList,insertItem) {
    for (let j = 0; j < treeList.length; j++) {
      let superItem = treeList[j];
      if (superItem.id == insertItem.superior_id) {
        superItem.children.push(this.getTreeDataFromItem(insertItem));

        return true;
      }
      else
      {
        let isFound = this.addItemToTree(superItem.children,insertItem);
        if (isFound)
        {
          return true;
        }
      }
    }

    return false;
  }

  getTreeDataFromItem(item)
  {
    let children = [];

    return {
      title:item.pet_name,
      value:item.pet_name,
      key:item.id,
      children:children,
      id:item.id,
      nick_name:item.nick_name,
      superior_id:item.superior_id,
    }
  }

  /**
   * 获取下级列表
   */
  getMyAgent = async () => {
    let url = fetchUrl.admin.myAgentList;
    let res = await service.fetchData({
      path: url,
      params: {}
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        if (res.success) {
          this.agentList = [].concat(res.data);

          //树型结构列表
          let treeList = [];
          //未匹配列表
          let notFoundList = [];

          //创建当前用户为顶层
          let baseTreeData = this.getTreeDataFromItem(login_user_store);
          treeList.push(baseTreeData);


          let baseId = login_user_store.id;

          let count = this.agentList.length;
          //由于数据是按最高级到最低级排序的,所以可以依次取数据
          for (let i = 0; i < count; i++) {
            let item = this.agentList[i];

            let isFound = this.addItemToTree(treeList,item);

            if (!isFound) {
              notFoundList.push(item);
            }
          }

          //未匹配的最后匹配一次,如果还没有找到,就先不处理
          for (let i = 0; i < notFoundList.length; i++)
          {
            let item = notFoundList[i];
            this.addItemToTree(treeList,item);
          }

          this.agentTreeList = [].concat(treeList);

          this.saveLocalData()
        }
      }
    });
    return res;
  }


}

let myAgentstore = new MyAgentStore();
// console.log(login_user_store);

export default myAgentstore;



// WEBPACK FOOTER //
// ./src/Store/LoginUser/MyAgentStore.js